import {submitEvent, submitMerge, submitMiniAction, submitMove, trackOnNextPageImpression} from "@otto-ec/tracking-bct";
import {getPagecluster} from "@otto-ec/global-resources/misc";
import {captureError} from "@otto-ec/global-resources/apm";
import {defaultApmLabels} from "@kestrel/bundle-metadata";

export default class TrackingService {

    async sendClickTrackingEvent(promoType, featureOrder, featureIndex, filledSlots, position, tile, masFeatureTrackingLabels) {
        const clickTrackingInfo = this._buildClickTrackingPayload(promoType, tile.destinationUrl, featureOrder, featureIndex, filledSlots, position, tile.sourceUrl);

        const featureTrackingData = {
            name: "click",
            features: [
                this._createContainerLabel(featureOrder, featureIndex, filledSlots, "clicked", promoType, masFeatureTrackingLabels),
                this._createTileLabel(position, featureOrder, tile.destinationUrl, tile.sourceUrl, tile.imageId, "clicked", promoType),
            ]
        };

        const results = await Promise.allSettled([
            submitMove(clickTrackingInfo, featureTrackingData),
            trackOnNextPageImpression({"promo_Click": [promoType]})
        ]);
        results
            .filter(result => result.status === "rejected")
            .forEach(result => this._captureTrackingError(result.reason, "click"));
    }

    async sendClickTrackingEventForPopup(promoType, featureOrder, featureIndex, filledSlots, position, tile, masFeatureTrackingLabels) {
        const clickTrackingInfo = this._buildClickTrackingPayload(promoType, tile.destinationUrl, featureOrder, featureIndex, filledSlots, position, tile.sourceUrl);
        const featureTrackingData = {
            name: "open",
            features: [
                this._createContainerLabel(featureOrder, featureIndex, filledSlots, "clicked", promoType, masFeatureTrackingLabels),
                this._createTileLabel(position, featureOrder, tile.destinationUrl, tile.sourceUrl, tile.imageId, "clicked", promoType),
            ]
        }
        try {
            await submitEvent(clickTrackingInfo, featureTrackingData)
        } catch (error) {
            this._captureTrackingError(error, "popup-click")
        }
    }

    async sendLoadedTrackingEvent(promoType, featureOrder, featureIndex, filledSlots, tiles, masFeatureTrackingLabels) {
        let trackingData = [this._createContainerLabel(featureOrder, featureIndex, filledSlots, "loaded", promoType, masFeatureTrackingLabels)];
        tiles.forEach(tile => {
            if (tile && Object.keys(tile).length !== 0) {
                const tileLabel = this._createTileLabel(tile.position, featureOrder, tile.destinationUrl, tile.sourceUrl, tile.imageId, "loaded", promoType);
                trackingData.push(tileLabel);
            }
        })
        try {
            await submitMerge({}, trackingData)
        } catch (error) {
            this._captureTrackingError(error, "loaded")
        }
    }

    async sendScrollTrackingEvent(promoType, featureOrder, tilePositions) {
        let parentFeature = {'featureId': this._createFeatureId(promoType, featureOrder)}
        let tileFeatures = tilePositions.map(position => {
            return {'featureId': this._createChildFeatureId(promoType, featureOrder, position)}
        })
        try {
            await submitMiniAction([parentFeature, ...tileFeatures])
        } catch (error) {
            this._captureTrackingError(error, "scroll")
        }
    }

    _captureTrackingError(error, trackingEvent) {
        captureError(
            error,
            {...defaultApmLabels, module: "staticpromo", tracking_event: trackingEvent},
            {type: "staticpromo-tracking"}
        );
    }

    _createContainerLabel(featureOrder, featureIndex, filledSlots, status, promoType, masFeatureTrackingLabels) {
        const staticPromoFeatureLabels = {
            promo_Feature: ["true"],
            promo_FeatureNumber: [(featureIndex + 1).toString()]
        };
        const labels = {
            ...masFeatureTrackingLabels,
            ...staticPromoFeatureLabels
        }
        let containerTrackingLabel = {
            id: this._createFeatureId(promoType, featureOrder),
            name: promoType,
            position: featureOrder,
            status: status,
            labels: labels
        };
        if (promoType === "StaticPromotion") {
            containerTrackingLabel.labels["promo_FilledSlots"] = [filledSlots.toString()]
        }
        return containerTrackingLabel
    }

    _createTileLabel(position, featureOrder, urlPath, source, imageId, status, promoType) {
        /*                                                                                                                                 */
        urlPath = (urlPath) ? urlPath : "n/a"
        source = (source) ? source : "n/a"
        imageId = (imageId) ? imageId : "n/a"

        let labels = {
            promo_Content: [urlPath],
            promo_Source: [source],
            promo_ImageId: [imageId]
        };
        if (urlPath.indexOf("selektion=") >= 0) {
            labels.promo_TargetPsr = [urlPath.split("selektion=")[1].split("&")[0]];
        }
        return {
            id: this._createChildFeatureId(promoType, featureOrder, position),
            parentId: this._createFeatureId(promoType, featureOrder),
            name: promoType + "-Teaser",
            position: position,
            status: status,
            labels: labels
        }
    }

    _createFeatureId(promoType, featureOrder) {
        return this._getIdPrefix(promoType) + featureOrder;
    }

    _createChildFeatureId(promoType, featureOrder, position) {
        return this._getIdPrefix(promoType) + featureOrder + "_teaser" + position;
    }

    _getIdPrefix(promoType) {
        switch (promoType) {
            case "StaticPromotion" :
                return "ft3_sp"
            default:
                return "unknown"
        }
    }

    _buildClickTrackingPayload(promoType, destination, featureOrder, featureIndex, filledSlots, position, source) {
        const clickTrackingInfo = {};
        let pageCluster = getPagecluster();
        clickTrackingInfo["wk.promo_AttributionFeature"] = [`${promoType}_${pageCluster}`];
        clickTrackingInfo["wk.promo_AttributionSource"] = [(source) ? source : promoType];
        return clickTrackingInfo;
    }

}
